import { Controller } from "@hotwired/stimulus"

// Polls for new messages in the active conversation
export default class extends Controller {
  static values = {
    conversationId: Number,
    lastMessageId: Number,
    interval: { type: Number, default: 5000 } // 5 seconds
  }

  connect() {
    this.isDisconnected = false
    this.boundHandleVisibilityChange = this.handleVisibilityChange.bind(this)
    this.startPolling()
    
    // Pause polling when tab is not visible
    document.addEventListener('visibilitychange', this.boundHandleVisibilityChange)
  }

  disconnect() {
    this.isDisconnected = true  // Flag to abort any in-flight requests
    this.stopPolling()
    document.removeEventListener('visibilitychange', this.boundHandleVisibilityChange)
  }

  startPolling() {
    if (this.pollingTimer || this.isDisconnected) return
    
    this.pollingTimer = setInterval(() => {
      if (!this.isDisconnected) {
        this.checkForNewMessages()
      }
    }, this.intervalValue)
  }

  stopPolling() {
    if (this.pollingTimer) {
      clearInterval(this.pollingTimer)
      this.pollingTimer = null
    }
  }

  handleVisibilityChange() {
    if (this.isDisconnected) return
    
    if (document.hidden) {
      this.stopPolling()
    } else {
      this.checkForNewMessages() // Check immediately when tab becomes visible
      this.startPolling()
    }
  }

  async checkForNewMessages() {
    if (this.isDisconnected) return  // Don't fetch if disconnected
    
    try {
      const response = await fetch(
        `/conversations/${this.conversationIdValue}/poll_messages?last_message_id=${this.lastMessageIdValue}`,
        {
          headers: {
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        }
      )

      if (!response.ok || this.isDisconnected) return  // Check again after async

      const data = await response.json()
      
      if (this.isDisconnected) return  // Check again after parsing
      
      if (data.new_messages && data.html) {
        this.appendMessages(data.html)
        this.lastMessageIdValue = data.last_message_id
      }
    } catch (error) {
      if (!this.isDisconnected) {
        console.error('Error polling for messages:', error)
      }
    }
  }

  appendMessages(html) {
    if (this.isDisconnected) return
    
    const messagesContainer = this.element.querySelector('turbo-frame#messages-list') || 
                              this.element.querySelector('#messages-list')
    
    if (messagesContainer) {
      messagesContainer.insertAdjacentHTML('beforeend', html)
      
      // Scroll to bottom
      const scrollContainer = document.getElementById('messages-container')
      if (scrollContainer) {
        scrollContainer.scrollTop = scrollContainer.scrollHeight
      }
    }
  }
}
